import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

const firebaseConfig = {
    apiKey: "AIzaSyA_dpeK0Mgiz3ciDMwGCCblXzcu9Pmr19Q",

    authDomain: "rzi-event.firebaseapp.com",

    projectId: "rzi-event",

    storageBucket: "rzi-event.appspot.com",

    messagingSenderId: "390230367653",

    appId: "1:390230367653:web:a555660377fe2d23ab5c4c"

};
firebase.initializeApp(firebaseConfig);

const firestore = firebase.firestore();
const storage = firebase.storage();
export { storage, firestore };
